import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { Button, Input, Loading } from '../../components/all';
import toast from '../../utils/toast';

import useInstrutorStore from '../../store/useInstrutorStore';
import useInstrutor from '../../hooks/useInstrutor';

export default function ListAlunosView() {
    const { GetAlunos, loading } = useInstrutor();
    const { instrutor } = useInstrutorStore();
    const [error, setError] = useState(null);
    const [alunos, setAlunos] = useState([]);
    const [alunosFiltrados, setAlunosFiltrados] = useState([]);

    const navigate = useNavigate();
    const mensagem = encodeURIComponent('Olá! Vamos marcar uma Aula?');

    useEffect(() => {
        if (!instrutor?.instrutor_id) return;

        const fetchAlunos = async () => {
            setError(null);
            try {
                const data = await GetAlunos(instrutor.instrutor_id);
                setAlunos(data || []);
                setAlunosFiltrados(data || []);
                if (!data || data.length === 0) {
                    setError('Nenhum aluno encontrado.');
                }
            } catch (error) {
                setError(error.message);
                showToast('error', error.message);
            }
        };

        fetchAlunos();
    }, [instrutor?.instrutor_id]);


    const showToast = (type, message) => {
        toast.dismiss();
        toast[type](message);
    };

    const marcarAula = (aluno) => {
        navigate('/selecionarFormaAgendamento', { state: { aluno } });
    };

    const pesquisarAluno = (valor) => {
        setError(null);

        if (!valor) {
            setAlunosFiltrados(alunos);
            return;
        }

        const res = alunos.filter((aluno) => {
            const nomeCompleto = `${aluno.nome || ''} ${aluno.sobrenome || ''}`.toLowerCase();
            return nomeCompleto.includes(valor.toLowerCase());
        });

        setAlunosFiltrados(res);
    };

    const renderAlunoItem = (aluno) => (
        <div
            key={aluno.usuario_id}
            className="group border border-gray-200 rounded-lg sm:rounded-xl p-3 sm:p-4 bg-white shadow-sm hover:shadow-md transition-all grid grid-cols-1 sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4"
        >
            <div className="flex flex-col w-full min-w-0">
                <span className="text-[7px] sm:text-[8px] text-gray-500 text-start">{aluno.usuario_id}</span>
                <span className="font-semibold text-sm sm:text-base text-gray-800 capitalize leading-tight text-start truncate">
                    {aluno.nome || 'Não especificado'} {aluno.sobrenome || ''}
                </span>
                <span className="text-xs sm:text-sm text-gray-500 text-start">Aluno ativo</span>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-2 gap-2 w-full">
                <Button
                    type={2}
                    className="h-8 sm:h-9 px-2 sm:px-3 text-xs sm:text-sm whitespace-nowrap"
                    onClick={() =>
                        window.open(`https://wa.me/55${aluno.telefone}?text=${mensagem}`, '_blank')
                    }
                >
                    <span className="material-icons text-[12px] sm:text-[12px]">forum</span>
                    <span className="hidden sm:inline">Contato</span>
                </Button>

                <Button
                    className="h-8 sm:h-9 px-2 sm:px-3 text-xs sm:text-sm whitespace-nowrap"
                    onClick={() => marcarAula(aluno)}
                >
                    <span className="material-icons text-[12px] sm:text-[12px]">add</span>
                    <span className="hidden sm:inline">Aula</span>
                </Button>
            </div>
        </div>
    );

    return (
        <div className="flex flex-col w-full min-h-screen max-w-screen-xl mx-auto px-3 sm:px-4 md:px-6 gap-3 sm:gap-4 pt-12 sm:pt-16 pb-6 relative">
            <div className="flex flex-col gap-1 text-center sticky top-12 sm:top-16 bg-white z-10 py-2">
                <h1 className="text-xl sm:text-2xl font-bold text-gray-900">Alunos</h1>
                <p className="text-xs sm:text-sm text-gray-500">
                    Total ativos: <strong>{alunos.length}</strong>
                </p>
            </div>

            <Input
                onChange={(e) => pesquisarAluno(e.target.value)}
                placeholder="Buscar aluno pelo nome..."
                className="sticky top-24 sm:top-28 z-10"
            />

            {loading && <Loading />}

            {error || alunos.length === 0 ? (
                <div className="bg-red-50 border border-red-200 text-red-700 p-3 sm:p-4 rounded-lg text-sm text-center">
                    {error ? `Erro: ${error}` : 'Nenhum aluno encontrado'}
                </div>
            ) : (
                <div className="flex flex-col gap-2 sm:gap-3 max-h-[calc(100vh-300px)] overflow-y-auto pr-1">
                    {alunosFiltrados.length > 0 ? (
                        alunosFiltrados.map(renderAlunoItem)
                    ) : (
                        <div className="text-center text-gray-400 py-6 sm:py-8 text-sm">
                            Nenhum aluno encontrado com esse filtro
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
